import React from 'react'
import { useDeleteRequest } from '../../../hooks/request'
import { useModal } from '../../../hooks/modal'
import Loader from '../../../components/common/Loader'
import SecretCodeUpdate from './SecretCodeUpdate'

export default function SecretCodeItem({ item, category, index }) {
    const brandRemove = useDeleteRequest({ url: '/main/secret-code/{id}'.replace('{id}', item.id) })
    const [showUpdateModal, hideUpdateModal] = useModal(
        <SecretCodeUpdate
            category={category}
            item={item}
            onSuccess={() => {
                category.request()
                hideUpdateModal()
            }}
            onCancel={() => hideUpdateModal()}
        />,
    )

    async function remove() {
        if (global.confirm('Сизни чинакамдан ўчиришни истайсизми?')) {
            await brandRemove.request()
            await category.request()
        }
    }

    return (
        <tr>
            <td>{index + 1}</td>
            <td>
                {item.code}
            </td>
            <td>
                <div className="is-pulled-right">
                    {!brandRemove.loading ? <i onClick={remove} className="icon pointer ion-md-trash" />
                        : <Loader className="icon" />}

                    <i onClick={showUpdateModal} className="icon pointer ion-md-create" />
                </div>
            </td>
        </tr>
    )
}
